import React, { useState, useEffect, useRef } from 'react';
import { createClient } from '@supabase/supabase-js';
import './ChatArk.css';

// ===========================================
// SUPABASE CLIENT
// ===========================================

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// ===========================================
// SVG ICON COMPONENTS
// ===========================================

const Icons = {
  Lock: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  Shield: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Link: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  Lightbulb: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
    </svg>
  ),
  File: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Check: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  MessageCircle: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  ),
  Globe: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Download: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  ),
  Smartphone: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  Cloud: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  Unlock: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 9.9-1" />
    </svg>
  ),
  X: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  ArrowRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  ),
};

// ===========================================
// DUAL PLATFORM DEMO COMPONENT
// ===========================================

const DualPlatformDemo = () => {
  const [activeChat, setActiveChat] = useState('whatsapp');
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [showBadge, setShowBadge] = useState(false);
  const [showEncryption, setShowEncryption] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  const waRef = useRef(null);
  const tgRef = useRef(null);

  const showMessage = (id) => {
    setVisibleMessages(prev => [...prev, id]);
  };

  useEffect(() => {
    let timeouts = [];

    const runAnimation = () => {
      // Reset
      setActiveChat('whatsapp');
      setVisibleMessages([]);
      setShowBadge(false);
      setShowEncryption(false);
      setTransitioning(false);

      // Show badge
      timeouts.push(setTimeout(() => setShowBadge(true), 300));

      // WhatsApp sequence
      timeouts.push(setTimeout(() => showMessage('wa-0'), 800));
      timeouts.push(setTimeout(() => showMessage('wa-1'), 2200));
      timeouts.push(setTimeout(() => showMessage('wa-2'), 3600));
      timeouts.push(setTimeout(() => showMessage('wa-3'), 6000));
      timeouts.push(setTimeout(() => showMessage('wa-4'), 7000));
      timeouts.push(setTimeout(() => setShowEncryption(true), 7800));
      timeouts.push(setTimeout(() => setShowEncryption(false), 8800));

      // Transition
      timeouts.push(setTimeout(() => {
        setTransitioning(true);
        setShowBadge(false);
      }, 9000));

      timeouts.push(setTimeout(() => {
        setActiveChat('telegram');
        setVisibleMessages([]);
      }, 9500));

      timeouts.push(setTimeout(() => {
        setTransitioning(false);
        setShowBadge(true);
      }, 10200));

      // Telegram sequence
      timeouts.push(setTimeout(() => showMessage('tg-0'), 10500));
      timeouts.push(setTimeout(() => showMessage('tg-1'), 11900));
      timeouts.push(setTimeout(() => showMessage('tg-2'), 13300));
      timeouts.push(setTimeout(() => showMessage('tg-3'), 15700));
      timeouts.push(setTimeout(() => showMessage('tg-4'), 16700));
      timeouts.push(setTimeout(() => setShowEncryption(true), 17500));

      // Loop
      timeouts.push(setTimeout(() => runAnimation(), 20000));
    };

    runAnimation();

    return () => timeouts.forEach(t => clearTimeout(t));
  }, []);

  // Auto-scroll effect
  useEffect(() => {
    if (activeChat === 'whatsapp' && waRef.current) {
      waRef.current.scrollTop = waRef.current.scrollHeight;
    } else if (activeChat === 'telegram' && tgRef.current) {
      tgRef.current.scrollTop = tgRef.current.scrollHeight;
    }
  }, [visibleMessages, activeChat]);

  return (
    <div className="demo-container-new">
      <div className={`platform-badge ${showBadge ? 'visible' : ''}`}>
        {activeChat === 'whatsapp' ? 'WhatsApp' : 'Telegram'}
      </div>

      <div className="phone-frame">
        <div className="phone-screen">

          {/* WhatsApp Chat */}
          <div className={`whatsapp-chat ${activeChat === 'whatsapp' ? 'active' : ''}`}>
            <div className="wa-header">
              <span className="wa-back">‹</span>
              <div className="wa-avatar">SI</div>
              <div className="wa-header-info">
                <div className="wa-header-name">Startup Ideas 💡</div>
                <div className="wa-header-members">Nick, Sarah, You</div>
              </div>
            </div>

            <div className="wa-messages" ref={waRef}>
              <div className={`wa-message other ${visibleMessages.includes('wa-0') ? 'visible' : ''}`}>
                <div className="wa-sender">Nick</div>
                <div className="wa-text">I shared an article about edge compute a while back... can't remember where it went</div>
                <div className="wa-time">10:42 AM</div>
              </div>

              <div className={`wa-message user ${visibleMessages.includes('wa-1') ? 'visible' : ''}`}>
                <div className="wa-text"><span className="wa-mention">@ChatArk</span> What was that edge compute article Nick shared?</div>
                <div className="wa-time">10:42 AM</div>
              </div>

              <div className={`wa-message bot ${visibleMessages.includes('wa-2') ? 'visible' : ''}`}>
                <div className="wa-sender">ChatArk</div>
                <div className="wa-text">Found it! 📎</div>
                <div className="wa-bot-card">
                  <div className="wa-card-type">🔗 LINK</div>
                  <div className="wa-card-title">The Future of Edge Computing</div>
                  <div className="wa-card-meta">Shared by Nick • 3 weeks ago</div>
                  <div className="wa-card-context">"Check this out — could be huge for the API idea we discussed"</div>
                </div>
                <div className="wa-time">10:42 AM</div>
              </div>

              <div className={`wa-message user ${visibleMessages.includes('wa-3') ? 'visible' : ''}`}>
                <div className="wa-text">What API idea?</div>
                <div className="wa-time">10:43 AM</div>
              </div>

              <div className={`wa-message bot ${visibleMessages.includes('wa-4') ? 'visible' : ''}`}>
                <div className="wa-sender">ChatArk</div>
                <div className="wa-typing">
                  <span></span><span></span><span></span>
                </div>
              </div>
            </div>
          </div>

          {/* Telegram Chat */}
          <div className={`telegram-chat ${activeChat === 'telegram' ? 'active' : ''}`}>
            <div className="tg-header">
              <span className="tg-back">‹</span>
              <div className="tg-avatar">SI</div>
              <div className="tg-header-info">
                <div className="tg-header-name">Startup Ideas</div>
                <div className="tg-header-members">3 members, 1 online</div>
              </div>
            </div>

            <div className="tg-messages" ref={tgRef}>
              <div className={`tg-message other ${visibleMessages.includes('tg-0') ? 'visible' : ''}`}>
                <div className="tg-sender">Nick</div>
                <div className="tg-text">I shared an article about edge compute a while back... can't remember where it went</div>
                <div className="tg-time">10:42</div>
              </div>

              <div className={`tg-message user ${visibleMessages.includes('tg-1') ? 'visible' : ''}`}>
                <div className="tg-text"><span className="tg-mention">@ChatArkBot</span> What was that edge compute article Nick shared?</div>
                <div className="tg-time">10:42</div>
              </div>

              <div className={`tg-message bot ${visibleMessages.includes('tg-2') ? 'visible' : ''}`}>
                <div className="tg-sender">ChatArk <span className="tg-bot-badge">BOT</span></div>
                <div className="tg-text">Found it!</div>
                <div className="tg-bot-card">
                  <div className="tg-card-type">
                    <Icons.Link /> Link
                  </div>
                  <div className="tg-card-title">The Future of Edge Computing</div>
                  <div className="tg-card-meta">Shared by Nick • 3 weeks ago • #startup-ideas</div>
                  <div className="tg-card-link">medium.com/edge-computing-2026...</div>
                  <div className="tg-card-context">"Check this out — could be huge for the API idea we discussed"</div>
                </div>
                <div className="tg-time">10:42</div>
              </div>

              <div className={`tg-message user ${visibleMessages.includes('tg-3') ? 'visible' : ''}`}>
                <div className="tg-text">What API idea?</div>
                <div className="tg-time">10:43</div>
              </div>

              <div className={`tg-message bot ${visibleMessages.includes('tg-4') ? 'visible' : ''}`}>
                <div className="tg-sender">ChatArk <span className="tg-bot-badge">BOT</span></div>
                <div className="tg-typing">
                  <span></span><span></span><span></span>
                </div>
              </div>
            </div>
          </div>

          {/* Transition overlay */}
          <div className={`transition-overlay ${transitioning ? 'visible' : ''}`}>
            <div className="transition-text">Switching to Telegram...</div>
          </div>

        </div>
      </div>

      {/* Encryption badge */}
      <div className={`encryption-badge-new ${showEncryption ? 'visible' : ''}`}>
        <Icons.Lock />
        <div className="encryption-info">
          <span className="encryption-title">End-to-end encrypted</span>
          <span className="encryption-sub">We see: aGVsbG8gd29ybGQ...</span>
        </div>
      </div>
    </div>
  );
};

// ===========================================
// PAGE COMPONENTS - Defined OUTSIDE ChatArk
// ===========================================

// Landing Page Component
const LandingPage = ({ setCurrentPage }) => (
  <div className="landing">
    {/* Hero */}
    <section className="hero">
      <div className="hero-bg">
        <div className="grid-overlay" />
        <div className="gradient-orb orb-1" />
        <div className="gradient-orb orb-2" />
        <div className="noise-overlay" />
      </div>

      <nav className="nav">
        <div className="logo">
          <span className="logo-icon">◈</span>
          <span className="logo-text">ChatArk</span>
        </div>
        <div className="nav-badge">
          <Icons.Lock />
          <span>End-to-end encrypted</span>
        </div>
      </nav>

      <div className="hero-content">
        <div className="badge">
          <span className="badge-dot" />
          Building
        </div>

        <h1 className="hero-title">
          Your group chat's<br />
          <span className="title-accent">second brain</span>
        </h1>

        <p className="hero-subtitle">
          An Agent that monitors your Telegram, Discord & WhatsApp groups. Organizes
          every link, idea, and file so you can find it months later by just asking.
        </p>

        <p className="hero-privacy">
          <Icons.Shield />
          <span>Your messages are encrypted before they leave your device. We can't read them. Ever.</span>
        </p>

        <button
          className="cta-button"
          onClick={() => setCurrentPage('pricing')}
        >
          See Pricing
          <span className="cta-arrow"><Icons.ArrowRight /></span>
        </button>

        <div className="platform-icons">
          <span className="platform">Telegram</span>
          <span className="platform-dot">•</span>
          <span className="platform">Discord</span>
          <span className="platform-dot">•</span>
          <span className="platform">WhatsApp</span>
        </div>
      </div>

      <div className="hero-visual">
        <DualPlatformDemo />
      </div>
    </section>

    {/* Problem Section */}
    <section className="problem">
      <div className="section-inner">
        <h2 className="section-title">Group chats are where ideas go to die.</h2>

        <div className="pain-points">
          <div className="pain-card">
            <p>"We talked about this 3 weeks ago... who shared that link?"</p>
          </div>
          <div className="pain-card">
            <p>"Someone had a great idea... was it in Telegram or Discord?"</p>
          </div>
          <div className="pain-card">
            <p>"I know we discussed this..."<span className="scroll-text">*scrolls through 10,000 messages*</span></p>
          </div>
        </div>

        <p className="problem-statement">
          <span className="highlight">Not anymore.</span>
        </p>
      </div>
    </section>

    {/* How It Works */}
    <section className="how-it-works">
      <div className="section-inner">
        <h2 className="section-title">Dead simple</h2>

        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Add the bot</h3>
              <p>Invite ChatArk to your group. Works on Telegram, Discord, WhatsApp.</p>
            </div>
          </div>

          <div className="step-connector" />

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Keep chatting</h3>
              <p>It monitors silently. Every link, idea, and file gets organized in the background.</p>
            </div>
          </div>

          <div className="step-connector" />

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Just ask</h3>
              <p>Message the agent anytime: "What was that idea we had about X?" — found in seconds.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Privacy Section */}
    <section className="privacy-section">
      <div className="section-inner">
        <div className="privacy-badge-large"><Icons.Shield /></div>
        <h2 className="section-title">We can't read your messages.<br />By design.</h2>

        <div className="privacy-explainer">
          <div className="privacy-step">
            <div className="privacy-icon-box">
              <Icons.Smartphone />
            </div>
            <div className="privacy-detail">
              <h4>Encrypted on your device</h4>
              <p>Messages are encrypted before they ever leave your phone. You hold the only key.</p>
            </div>
          </div>

          <div className="privacy-arrow">→</div>

          <div className="privacy-step">
            <div className="privacy-icon-box">
              <Icons.Cloud />
            </div>
            <div className="privacy-detail">
              <h4>We store scrambled data</h4>
              <p>Our servers see gibberish. We couldn't read your chats even if we wanted to.</p>
            </div>
          </div>

          <div className="privacy-arrow">→</div>

          <div className="privacy-step">
            <div className="privacy-icon-box">
              <Icons.Unlock />
            </div>
            <div className="privacy-detail">
              <h4>Decrypted only by you</h4>
              <p>When you search, data is decrypted on your device. Nobody else can see it.</p>
            </div>
          </div>
        </div>

        <div className="privacy-code-demo">
          <div className="code-label">What we see:</div>
          <code className="encrypted-blob">
            U2FsdGVkX1+vupppZksvRf5pq5g5XjFRIipRkwB0K1Y=<br />
            aGVsbG8gd29ybGQgdGhpcyBpcyBlbmNyeXB0ZWQ=<br />
            xK8EjLmP9qR2sT5uVwYz1A3bC6dE8fGhIjKlMnOp...
          </code>
          <div className="code-label">What you see:</div>
          <div className="decrypted-preview">
            <div className="preview-item"><Icons.Link /> Edge Computing Article — shared by Nick</div>
            <div className="preview-item"><Icons.Lightbulb /> API pricing model idea — discussed with Sarah</div>
            <div className="preview-item"><Icons.File /> Competitor analysis.pdf — uploaded by Mike</div>
          </div>
        </div>
      </div>
    </section>

    {/* What It Captures */}
    <section className="captures">
      <div className="section-inner">
        <h2 className="section-title">Everything organized & searchable</h2>

        <div className="capture-grid">
          <div className="capture-card">
            <span className="capture-icon"><Icons.Link /></span>
            <h3>Links</h3>
            <p>Articles, tweets, videos, docs — auto-tagged and searchable</p>
          </div>
          <div className="capture-card">
            <span className="capture-icon"><Icons.Lightbulb /></span>
            <h3>Ideas</h3>
            <p>Discussions and decisions captured with full context</p>
          </div>
          <div className="capture-card">
            <span className="capture-icon"><Icons.File /></span>
            <h3>Files</h3>
            <p>Images, PDFs, docs — never lost in the scroll again</p>
          </div>
          <div className="capture-card">
            <span className="capture-icon"><Icons.Check /></span>
            <h3>Action Items</h3>
            <p>Tasks and to-dos mentioned in passing — surfaced when you need them</p>
          </div>
        </div>
      </div>
    </section>

    {/* Access Your Data */}
    <section className="access-section">
      <div className="section-inner">
        <h2 className="section-title">Access your stuff however you want</h2>

        <div className="access-options">
          <div className="access-card primary">
            <div className="access-icon"><Icons.MessageCircle /></div>
            <h3>Ask the bot</h3>
            <p>Ask ChatArk anytime with natural questions. It searches your encrypted vault and returns results instantly.</p>
            <span className="access-tag">Recommended</span>
          </div>

          <div className="access-card">
            <div className="access-icon"><Icons.Globe /></div>
            <h3>Web dashboard</h3>
            <p>Browse, search, and organize visually at ChatArk.app. Data decrypted in your browser.</p>
          </div>

          <div className="access-card">
            <div className="access-icon"><Icons.Download /></div>
            <h3>Export anywhere</h3>
            <p>Push to Notion, Google Sheets, or download as markdown. Your data, your choice.</p>
          </div>
        </div>
      </div>
    </section>

    {/* Who It's For */}
    <section className="audience">
      <div className="section-inner">
        <h2 className="section-title">Built for teams who live in chat</h2>

        <div className="audience-list">
          <div className="audience-item">
            <span className="audience-marker" />
            <span>Startup teams riffing on ideas</span>
          </div>
          <div className="audience-item">
            <span className="audience-marker" />
            <span>Crypto groups sharing alpha</span>
          </div>
          <div className="audience-item">
            <span className="audience-marker" />
            <span>Masterminds & paid communities</span>
          </div>
          <div className="audience-item">
            <span className="audience-marker" />
            <span>Freelancer collectives & agencies</span>
          </div>
          <div className="audience-item">
            <span className="audience-marker" />
            <span>Friends building side projects</span>
          </div>
        </div>
      </div>
    </section>

    {/* Final CTA */}
    <section className="final-cta">
      <div className="section-inner">
        <h2>Ready to stop forgetting ideas?</h2>
        <p className="final-cta-sub">End-to-end encrypted. Works on all platforms. Cancel anytime.</p>
        <button
          className="cta-button large"
          onClick={() => setCurrentPage('pricing')}
        >
          See Pricing
          <span className="cta-arrow"><Icons.ArrowRight /></span>
        </button>
      </div>
    </section>

    {/* Footer */}
    <footer className="footer">
      <div className="logo">
        <span className="logo-icon">◈</span>
        <span className="logo-text">ChatArk</span>
      </div>
      <p>© 2026 ChatArk. Your messages stay yours.</p>
    </footer>
  </div>
);

// Pricing Page Component
const PricingPage = ({ setCurrentPage, setSelectedPlan }) => (
  <div className="pricing-page">
    <div className="pricing-bg">
      <div className="grid-overlay" />
      <div className="gradient-orb orb-1" />
      <div className="gradient-orb orb-2" />
    </div>

    <nav className="nav">
      <button className="back-btn" onClick={() => setCurrentPage('landing')}>
        <Icons.ArrowLeft /> Back
      </button>
      <div className="logo">
        <span className="logo-icon">◈</span>
        <span className="logo-text">ChatArk</span>
      </div>
    </nav>

    <div className="pricing-content">
      <h1>Simple pricing. Cancel anytime.</h1>
      <p className="pricing-sub">All plans include end-to-end encryption. Your privacy is our priority.</p>

      <div className="pricing-cards">
        <div className="pricing-card free">
          <div className="plan-name">Free</div>
          <div className="plan-price">
            <span className="price">$0</span>
            <span className="period">forever</span>
          </div>
          <ul className="plan-features">
            <li><span className="check"><Icons.Check /></span> 1 group chat</li>
            <li><span className="check"><Icons.Check /></span> Forward Monitoring Only</li>
            <li><span className="check"><Icons.Check /></span> 90 Day History</li>
            <li><span className="check"><Icons.Check /></span> Unlimited bot queries</li>
            <li><span className="check"><Icons.Check /></span> End-to-end encrypted</li>
            <li><span className="check"><Icons.Check /></span> Telegram, Discord</li>
          </ul>
          <button
            className="plan-cta free-cta"
            onClick={() => { setSelectedPlan('free'); setCurrentPage('signup'); }}
          >
            Join Waitlist
          </button>
        </div>

        <div className="pricing-card pro">
          {/*<div className="popular-badge">Most Popular</div>*/}
          <div className="plan-name">Pro</div>
          <div className="plan-price">
            <span className="price">$15</span>
            <span className="period">/month</span>
          </div>
          <ul className="plan-features">
            <li><span className="check"><Icons.Check /></span> Unlimited group chats</li>
            <li><span className="check"><Icons.Check /></span> Import last 90 days</li>
            <li><span className="check"><Icons.Check /></span> Forever history</li>
            <li><span className="check"><Icons.Check /></span> Unlimited bot queries</li>
            <li><span className="check"><Icons.Check /></span> Web dashboard access</li>
            <li><span className="check"><Icons.Check /></span> Export to Notion/Sheets</li>
            <li><span className="check"><Icons.Check /></span> Priority support</li>
            <li><span className="check"><Icons.Check /></span> End-to-end encrypted</li>
          </ul>
          <button
            className="plan-cta pro-cta"
            onClick={() => { setSelectedPlan('pro'); setCurrentPage('signup'); }}
          >
            Get Early Access
            <span className="cta-arrow"><Icons.ArrowRight /></span>
          </button>
        </div>
      </div>

      <div className="pricing-trust">
        <div className="trust-item">
          <Icons.Shield />
          <span>End-to-end encrypted</span>
        </div>
        <div className="trust-item">
          <Icons.Lock />
          <span>We can't read your data</span>
        </div>
        <div className="trust-item">
          <Icons.Download />
          <span>Export anytime</span>
        </div>
      </div>
    </div>
  </div>
);

// Signup Page Component
const SignupPage = ({
  setCurrentPage,
  email,
  setEmail,
  platform,
  setPlatform,
  groupCount,
  setGroupCount,
  submitted,
  handleSubmit,
  isSubmitting,
  submitError
}) => (
  <div className="signup-page">
    <div className="pricing-bg">
      <div className="grid-overlay" />
      <div className="gradient-orb orb-1" />
      <div className="gradient-orb orb-2" />
    </div>

    <nav className="nav">
      <button className="back-btn" onClick={() => setCurrentPage('pricing')}>
        <Icons.ArrowLeft /> Back
      </button>
      <div className="logo">
        <span className="logo-icon">◈</span>
        <span className="logo-text">ChatArk</span>
      </div>
    </nav>

    <div className="signup-content">
      {!submitted ? (
        <>
          <h1>You're in.</h1>
          <p className="signup-subtitle">
            We're launching soon to a small group. Drop your email and we'll
            reach out when it's your turn.
          </p>

          <form className="signup-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label>Which platforms do you use?</label>
              <div className="radio-group">
                <label className={`radio-option ${platform === 'telegram' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="platform"
                    value="telegram"
                    checked={platform === 'telegram'}
                    onChange={(e) => setPlatform(e.target.value)}
                  />
                  <span className="radio-label">Telegram</span>
                </label>
                <label className={`radio-option ${platform === 'discord' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="platform"
                    value="discord"
                    checked={platform === 'discord'}
                    onChange={(e) => setPlatform(e.target.value)}
                  />
                  <span className="radio-label">Discord</span>
                </label>
                <label className={`radio-option ${platform === 'whatsapp' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="platform"
                    value="whatsapp"
                    checked={platform === 'whatsapp'}
                    onChange={(e) => setPlatform(e.target.value)}
                  />
                  <span className="radio-label">WhatsApp</span>
                </label>
                <label className={`radio-option ${platform === 'multiple' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="platform"
                    value="multiple"
                    checked={platform === 'multiple'}
                    onChange={(e) => setPlatform(e.target.value)}
                  />
                  <span className="radio-label">Multiple</span>
                </label>
              </div>
            </div>

            <div className="form-group">
              <label>How many group chats would you use this in?</label>
              <div className="radio-group">
                <label className={`radio-option ${groupCount === '1' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="groupCount"
                    value="1"
                    checked={groupCount === '1'}
                    onChange={(e) => setGroupCount(e.target.value)}
                  />
                  <span className="radio-label">1</span>
                </label>
                <label className={`radio-option ${groupCount === '2-5' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="groupCount"
                    value="2-5"
                    checked={groupCount === '2-5'}
                    onChange={(e) => setGroupCount(e.target.value)}
                  />
                  <span className="radio-label">2-5</span>
                </label>
                <label className={`radio-option ${groupCount === '5+' ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="groupCount"
                    value="5+"
                    checked={groupCount === '5+'}
                    onChange={(e) => setGroupCount(e.target.value)}
                  />
                  <span className="radio-label">5+</span>
                </label>
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Get Early Access'}
              {!isSubmitting && <span className="cta-arrow"><Icons.ArrowRight /></span>}
            </button>

            {submitError && (
              <p className="form-error">{submitError}</p>
            )}

            <p className="form-note">
              <Icons.Lock />
              No spam. Your data is end-to-end encrypted.
            </p>
          </form>
        </>
      ) : (
        <div className="success-message">
          <div className="success-icon"><Icons.Check /></div>
          <h1>You're on the list!</h1>
          <p>We'll reach out soon. In the meantime, tell your group chat about us?</p>
            <div className="share-buttons">
              <a
                href={`https://t.me/share/url?url=${encodeURIComponent('https://chatark.app')}&text=${encodeURIComponent('Just joined the waitlist for ChatArk - an AI that organizes your group chats!')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn telegram"
              >
                Share on Telegram
              </a>
              <a
                href={`https://twitter.com/intent/tweet?text=${encodeURIComponent('Just joined the waitlist for ChatArk - an AI that organizes your group chats!')}&url=${encodeURIComponent('https://chatark.app')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn twitter"
              >
                Share on X
              </a>
              <a
                href={`https://wa.me/?text=${encodeURIComponent('Just joined the waitlist for ChatArk - an AI that organizes your group chats! https://chatark.app')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="share-btn whatsapp"
              >
                Share on WhatsApp
              </a>
            </div>
        </div>
      )}
    </div>
  </div>
);

// Exit Intent Modal Component
const ExitModal = ({ setExitIntent }) => {
  const [exitReason, setExitReason] = useState('');
  const [exitDetails, setExitDetails] = useState('');
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);

  const handleExitSubmit = async () => {
    setIsSubmittingFeedback(true);

    try {
      if (supabase && (exitReason || exitDetails)) {
        await supabase
          .from('exit_feedback')
          .insert([{
            reason: exitReason,
            details: exitDetails
          }]);
      }
    } catch (err) {
      console.error('Feedback submission error:', err);
    } finally {
      setIsSubmittingFeedback(false);
      setExitIntent(false);
    }
  };

  return (
    <div className="exit-modal-overlay" onClick={() => setExitIntent(false)}>
      <div className="exit-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-modal" onClick={() => setExitIntent(false)}>
          <Icons.X />
        </button>
        <h2>Before you go —</h2>
        <p>What's stopping you?</p>
        <div className="exit-options">
          <label className="exit-option">
            <input
              type="radio"
              name="exitReason"
              value="problem"
              checked={exitReason === 'problem'}
              onChange={(e) => setExitReason(e.target.value)}
            />
            <span>Not sure it solves my problem</span>
          </label>
          <label className="exit-option">
            <input
              type="radio"
              name="exitReason"
              value="price"
              checked={exitReason === 'price'}
              onChange={(e) => setExitReason(e.target.value)}
            />
            <span>Price is too high</span>
          </label>
          <label className="exit-option">
            <input
              type="radio"
              name="exitReason"
              value="trust"
              checked={exitReason === 'trust'}
              onChange={(e) => setExitReason(e.target.value)}
            />
            <span>Still worried about privacy</span>
          </label>
          <label className="exit-option">
            <input
              type="radio"
              name="exitReason"
              value="platforms"
              checked={exitReason === 'platforms'}
              onChange={(e) => setExitReason(e.target.value)}
            />
            <span>Need a different platform</span>
          </label>
          <label className="exit-option">
            <input
              type="radio"
              name="exitReason"
              value="other"
              checked={exitReason === 'other'}
              onChange={(e) => setExitReason(e.target.value)}
            />
            <span>Something else</span>
          </label>
        </div>
        <textarea
          placeholder="Tell us more (optional)..."
          value={exitDetails}
          onChange={(e) => setExitDetails(e.target.value)}
        />
        <button
          className="exit-submit"
          onClick={handleExitSubmit}
          disabled={isSubmittingFeedback}
        >
          {isSubmittingFeedback ? 'Submitting...' : 'Submit Feedback'}
        </button>
      </div>
    </div>
  );
};

// ===========================================
// MAIN COMPONENT
// ===========================================

const ChatArk = () => {
  const [currentPage, setCurrentPage] = useState('landing');
  const [email, setEmail] = useState('');
  const [platform, setPlatform] = useState('');
  const [groupCount, setGroupCount] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [exitIntent, setExitIntent] = useState(false);
  const [exitIntentShown, setExitIntentShown] = useState(false);
  const [canShowExitIntent, setCanShowExitIntent] = useState(false);

  // Wait 10 seconds before enabling exit intent
  useEffect(() => {
    const timer = setTimeout(() => {
      setCanShowExitIntent(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY < 10 && currentPage === 'landing' && !exitIntentShown && canShowExitIntent) {
        setExitIntent(true);
        setExitIntentShown(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [currentPage, exitIntentShown, canShowExitIntent]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      if (!supabase) {
        console.warn('Supabase not configured, logging to console only');
        console.log({ email, platform, groupCount });
        setSubmitted(true);
        return;
      }

      const { error } = await supabase
        .from('waitlist')
        .insert([{ email, platform, group_count: groupCount, plan: selectedPlan }]);

      if (error) {
        if (error.code === '23505') {
          // Unique constraint violation - email already exists
          setSubmitError('This email is already on the waitlist!');
        } else {
          throw error;
        }
      } else {
        setSubmitted(true);
      }
    } catch (err) {
      console.error('Submission error:', err);
      setSubmitError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {currentPage === 'landing' && (
        <LandingPage setCurrentPage={setCurrentPage} />
      )}
      {currentPage === 'pricing' && (
        <PricingPage setCurrentPage={setCurrentPage} setSelectedPlan={setSelectedPlan} />
      )}
      {currentPage === 'signup' && (
        <SignupPage
          setCurrentPage={setCurrentPage}
          email={email}
          setEmail={setEmail}
          platform={platform}
          setPlatform={setPlatform}
          groupCount={groupCount}
          setGroupCount={setGroupCount}
          submitted={submitted}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          submitError={submitError}
        />
      )}
      {exitIntent && (
        <ExitModal setExitIntent={setExitIntent} />
      )}
    </>
  );
};

export default ChatArk;
